import { TipoVendaFormaPag } from "./enum";

export class VendaFormaPag {
  id: number;
  idCupom: string;
  idFormaPag: number;
  descricaoFormaPag: string;
  idCondPag: number;
  descricaoCondPag: string;
  tipo: TipoVendaFormaPag;
  valor: number;
  taxa: number;
  valorTaxa: number;
  rateio: number;
  valorRateio: number;
  total: number;
}
